import {customElement, bindable, bindingMode, computedFrom} from 'aurelia-framework';
import keyCode from 'keycode';

@customElement('standard-button')
export class StandardButton {

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) click = null;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) enter = null;

  @bindable({
    defaultBindingMode: bindingMode.oneWay
  }) disabled = false;

  @computedFrom('click', 'enter', 'disabled')
  get clazz() {
    return `${this.click || this.enter ? 'active' : ''} ${this.disabled ? 'disabled' : ''}`;
  }

  onClick(e) {
    if (this.click && !this.disabled) {
      this.click({e});
    }
  }

  onKeyUp(e) {
    if (keyCode(e) === 'enter' && !this.disabled) {
      this.enter ? this.enter({e}) : this.click();
    }
  }

}
